import { useState } from "react";

import { db, storage } from "../../../../util/firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Button, Modal, ModalBody, Input } from "reactstrap";

function AdminCreateLeaguePage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const sports = [
    "Soccer",
    "Football",
    "Baseball",
    "Hockey",
    "Racing",
    "Basketball",
    "MMA",
  ];

  const [image, setImage] = useState();
  const [name, setName] = useState();
  const [origin, setOrigin] = useState();
  const [sport, setSport] = useState();
  const [nextOpeningDateTime, setNextOpeningDateTime] = useState();

  const createLeague = async () => {
    try {
      setIsLoading(true);

      await addDoc(collection(db, "leagues"), {
        uid: uuidv4(),
        image: image,
        name: name,
        origin: origin,
        sportCategory: sport.toUpperCase(),
        nextOpeningDateTime: nextOpeningDateTime,
      });

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [newLeagueImage, setNewLeagueImage] = useState();
  const [newLeagueImagePreview, setNewLeagueImagePreview] = useState();
  const [changeLeagueImageModalIsOpen, setChangeLeagueImageModalIsOpen] =
    useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const toggleChangeLeagueImageModal = () => {
    setChangeLeagueImageModalIsOpen(!changeLeagueImageModalIsOpen);
  };

  const handleChangeNewLeagueImage = (e) => {
    setNewLeagueImage(e.target.files[0]);
    setNewLeagueImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewLeagueImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewLeagueImage = async () => {
    setIsModalLoading(true);

    const storageRef = ref(storage, `assets/leaguesNew/${newLeagueImage.name}`);
    await uploadBytesResumable(storageRef, newLeagueImage).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        setImage(downloadURL);
        setIsModalLoading(false);
        toggleChangeLeagueImageModal();
      });
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE LEAGUE
      </h1>
      <div>
        <div id="adminNewsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button
              onClick={toggleChangeLeagueImageModal}
              className="primaryBtn"
            >
              ADD
            </Button>
            <Modal
              id="changeNewsArticleImageModal"
              isOpen={changeLeagueImageModalIsOpen}
              toggle={toggleChangeLeagueImageModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleChangeLeagueImageModal} />
                </div>
                <div>
                  <h1>ADD IMAGE</h1>
                  {isModalLoading ? (
                    <div
                      style={{
                        height: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BarLoader color="#005EE1" />
                    </div>
                  ) : (
                    <div style={{ marginTop: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <img
                          alt="articleImage"
                          src={
                            newLeagueImagePreview
                              ? newLeagueImagePreview
                              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                          }
                          style={{ height: 250, width: 651.4 }}
                        />
                      </div>
                      <Input
                        id="selectImage"
                        type="file"
                        className="mainInput"
                        accept="image/*"
                        onChange={handleChangeNewLeagueImage}
                        style={{ display: "none" }}
                      />
                      <Button
                        onClick={selectNewLeagueImage}
                        className="secondaryBtn"
                        style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                      >
                        {newLeagueImage?.name
                          ? newLeagueImage.name
                          : "CHOOSE IMAGE (600x600px)"}
                      </Button>
                      <Button
                        onClick={handleUploadNewLeagueImage}
                        disabled={!newLeagueImage?.name}
                        className="primaryBtn"
                      >
                        ADD
                      </Button>
                    </div>
                  )}
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The league's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Origin
        </p>
        <input
          type="text"
          className="mainInput"
          value={origin}
          onChange={(e) => setOrigin(e.target.value)}
          placeholder="The league's origin"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Sport
        </p>
        {/* <input
          type='text'
          className="mainInput"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          placeholder="The league's sport"
          style={{marginBottom: '0.5rem'}}
        /> */}
        <Input
          type="select"
          className="mainInput"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The league's sport
          </option>
          {sports.map((sport, index) => (
            <option key={index} value={sport}>
              {sport}
            </option>
          ))}
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Next opening date
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={nextOpeningDateTime}
          onChange={(e) => setNextOpeningDateTime(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
        />
        <Button
          onClick={createLeague}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={!name}
        >
          CREATE LEAGUE
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateLeaguePage;
